<template>
  <div id="app" :class="$route.meta.theme">
    <header-nav
        :noMenu="$route.meta.noMenu"
        :theme="$route.meta.theme"
        :quick-menu="$route.meta.quickMenu"
        v-if="!$route.meta.noHav"
    ></header-nav>
    <login></login>
    <el-main>
      <keep-alive :include="['intellect-computed','intellect-design','intellect-eqdiscivil']">
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </el-main>
    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">{{beiAnNo}}</a> <br>
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802042269" target="_blank">
        <img :src="require('@/assets/beian.png')">
        <div class="beian-text">
          京公网安备 11010802042269号
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import headerNav from './components/header-nav'
import login from './components/login'
import {delCookie, getCookie} from "./util/cookie";
import {checkSessionApi} from "./api/login";
import {meApi} from "./api/account";
import {Message} from "element-ui";
import store from "./store/store";

export default {
  name: 'App',
  components: {
    headerNav,
    login
  },
  data() {
    return {
      beiAnNo: window.location.host.indexOf("deepseai.tech")>-1?'京ICP备2023013676号-2':'京ICP备2023013676号-1'
    };
    },
  created() {
    checkSessionApi().then(async res => {
      if (res.retCode === '0000' ) {
        let result = await meApi()
        if (result.retCode === "0000"){
          let userInfo = result.data;
          this.$store.dispatch('login/setUserInfo', userInfo);
        }
      } else {
        if (getCookie('g_session')) {
          Message.warning('登陆状态已过期');
          store.dispatch('login/showLoginDialog');
          store.dispatch('login/clearUserInfo');
        }
        delCookie('g_session');
        this.$router.push({name: 'home'});
      }
    });

    function receiveMessage(event) {
      // if (event.origin !== window.location.origin) {
      //   // 如果消息不是来自同源的子页面，则不处理
      //   return;
      // }

      const data = event.data;
      console.log('接收到子页面的消息：', data);
      if (data && data.command === 'backHome'){
        window.location.href = "/"
      }
    }

    window.addEventListener('message', receiveMessage, false);
  }
}
</script>

<style lang="less">

* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .beian{
    margin: 0 auto 10px;
    text-align: center;
    line-height: 20px;
    a {
      color: #000;
      text-decoration:none;
    }
    img {
      vertical-align: middle;
    }
    .beian-text{
      display: inline-block;
      vertical-align: middle;
    }
  }
  &.dark{
    min-width: 1152px;
    color: #2c3e50;
    background-position: center;
    background-image: url('~@/assets/main_bg.png');
    background-size: cover;
    text-align: center;
    .el-main{
      margin: 20px auto 0;
      min-width: 1152px;
      max-width: 1366px;
      width: 70%;
    }
    .beian{
      a {
        color: #eeeeee;
      }
      position: absolute;
      bottom: 10px;
      width: 100%;
    }
  }
}


.el-main{
  margin: 0px auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue